var _circle, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeparate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "H1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 193.9,
    cy: 64.3,
    r: 14.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.3,127.1l-25.1-11.7l-7-19.2l0,0c-2.9-6.7-8.9-11.9-16.5-13.2l-6-1c-6.3-1.1-12.3,0.6-17,4.2l-21.3,14.9l0,0 c-1.4,1-2.4,2.4-2.7,4.3v0.1l0,0l-5.3,29.6c-0.6,3.4,1.7,6.9,5.2,7.4s6.9-1.7,7.4-5.2l4.9-27.2c0,0,12.5-8.6,12.6-8.6l-8.3,47.3 l-5.9,34.5l-20.1,28.4c-2.9,4.2-1.9,9.9,2.3,12.7s9.9,1.9,12.7-2.3l21.1-30.1c0.9-1.1,1.3-2.4,1.4-3.7l0,0l4.7-27.1l16,22.9l6,34.2 c0.9,5,5.6,8.3,10.6,7.4c5-0.9,8.3-5.6,7.4-10.6l-6.4-36.2c-0.3-1.4-0.9-2.6-1.6-3.7l0,0L194,148.5l7.3-41.8l0,0l5.7,15.5l0,0 c0.6,1.6,1.7,3,3.4,3.7h0.1l0,0l27.4,12.7c3.3,1.4,7,0.1,8.6-3.2C248,132.4,246.6,128.6,243.3,127.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2,135.4c1.6,3.3,5.3,4.6,8.6,3.2l27.4-12.7l0,0h0.1c1.7-0.7,2.9-2.1,3.4-3.7l0,0l5.7-15.5l0,0l7.3,41.8l-18.5,26.9l0,0 c-0.7,1.1-1.3,2.3-1.6,3.7l-6.4,36.2c-0.9,5,2.4,9.7,7.4,10.6c5,0.9,9.7-2.4,10.6-7.4l6-34.2l16-22.9l4.7,27.1l0,0 c0.1,1.3,0.6,2.6,1.4,3.7l21.1,30.1c2.9,4.2,8.6,5.2,12.7,2.3c4.2-2.9,5.2-8.6,2.3-12.7l-20.1-28.4l-5.9-34.5l-8.3-47.3 c0.1,0,12.6,8.6,12.6,8.6l4.9,27.2c0.6,3.4,4,5.7,7.4,5.2c3.4-0.6,5.7-4,5.2-7.4l-5.3-29.6l0,0v-0.1c-0.3-1.9-1.3-3.3-2.7-4.3l0,0 L88.1,86.2c-4.7-3.6-10.7-5.3-17-4.2l-6,1c-7.6,1.3-13.6,6.4-16.5,13.2l0,0l-7,19.2l-25.1,11.7C13.2,128.6,11.8,132.4,13.2,135.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.4,77.8L59.4,77.8L59.4,77.8c2.3,0.7,13.5,1.6,21.4-12.4c3-5.8,3-13.5,3-13.5s-4,3.5-8.2,3.3c-2.8-0.2-6.3-2.3-7-2.8 c-1.6-0.9-3.3-1.6-5.4-1.9c-7.5-0.9-14.2,4.4-15.2,11.9C47.3,69.8,52.5,76.6,59.4,77.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparate);
export default __webpack_public_path__ + "static/media/separate.1daf803bab9668d51112d91719f80aeb.svg";
export { ForwardRef as ReactComponent };